document.addEventListener('DOMContentLoaded', function () {
    var btn = document.getElementById('toggleWorkshopBtn');
    if (btn) {
      
        const backClicked = new URLSearchParams(window.location.search).get('back');
        if (backClicked) {
            btn.click();
        }
    }
    
    var smoothDiv = document.querySelectorAll('.hidden-reg, .h-log');
    var loginBtn = document.querySelector('.h-l');

    if (smoothDiv.length > 0) {
        smoothDiv.forEach(function(smoothDiv) {
            smoothDiv.addEventListener('click', function(event) {
                if (loginBtn) {
                    loginBtn.style.display = 'none';
                }

                var targetSection = document.querySelector(smoothDiv.getAttribute('href'));

                if (targetSection) { 
                    targetSection.addEventListener('shown.bs.collapse', function () { 
                        targetSection.scrollIntoView({ behavior: 'smooth' });
                    }, { once: true });
                }
            });
        });
    }

    var registerButton = document.querySelector('[href="#register-guest-section"]');
    var loginButton = document.querySelector('[href="#login-workshop-section"]');
    var registerSection = document.getElementById('register-guest-section');
    var loginSection = document.getElementById('login-workshop-section');

    var loginCodeFieldLogin = document.getElementById('login_code_login');
    var loginCodeFieldRegister = document.getElementById('login_code_register');

    var authRegisterButton = document.querySelector('[href="#register-auth-section"]');
    var authRegisterSection = document.getElementById('register-auth-section');

    if (registerButton && loginButton && registerSection && loginSection) {

        registerButton.addEventListener('click', function() {

            if (loginSection.classList.contains('show')) {
                var bsCollapse = new bootstrap.Collapse(loginSection, { toggle: false });
                bsCollapse.hide(); 
            }
            registerButton.style.display = 'none';
            loginButton.parentElement.style.display = 'block';

            var bsCollapse = new bootstrap.Collapse(registerSection, { toggle: true });
            bsCollapse.show();

            if (loginCodeFieldLogin) {
                loginCodeFieldLogin.disabled = true;
            }
            if (loginCodeFieldRegister) {
                loginCodeFieldRegister.disabled = false;
            }
        });

        loginButton.addEventListener('click', function() { 

            if (registerSection.classList.contains('show')) {
                var bsCollapse = new bootstrap.Collapse(registerSection, { toggle: false });
                bsCollapse.hide();
            }
            loginButton.parentElement.style.display = 'none';
            registerButton.style.display = 'inline';

            var bsCollapse = new bootstrap.Collapse(loginSection, { toggle: true });
            bsCollapse.show();

            if (loginCodeFieldRegister) {
                loginCodeFieldRegister.disabled = true;
            }
            if (loginCodeFieldLogin) {
                loginCodeFieldLogin.disabled = false;
            }
        });
    }

    if (authRegisterButton && authRegisterSection) {
        authRegisterButton.addEventListener('click', function(event) { 
            event.preventDefault();

            var bsCollapse = new bootstrap.Collapse(authRegisterSection, { toggle: true });
            bsCollapse.show();

            authRegisterButton.style.display = 'none';
        });
    }
     
   var translations = {
        en: {
            'Days': 'Days',
            'Hours': 'Hours',
            'Minutes': 'Minutes',
            'Seconds': 'Seconds'
        },
        es: {
            'Days': 'Días',
            'Hours': 'Horas',
            'Minutes': 'Minutos',
            'Seconds': 'Segundos'
        },
        'pt-BR': {
            'Days': 'Dias',
            'Hours': 'Horas',
            'Minutes': 'Minutos',
            'Seconds': 'Segundos'
        }
    };
 
    var currentLanguage = window.currentLanguage || 'en';
 
    function translateFlipdown() {
        document.querySelectorAll('.rotor-group-heading').forEach(function(element) {
            var dataBefore = element.getAttribute('data-before');
            if (translations[currentLanguage][dataBefore]) {
                element.setAttribute('data-before', translations[currentLanguage][dataBefore]);
            }
        });
    }
 
    var flipdownElement = document.getElementById('flipdown');
    if (flipdownElement) {
        function getTimezoneOffset(timezone) {
            var localOffset = new Date().getTimezoneOffset();
            var workshopOffset = new Date(new Date().toLocaleString("en-US", { timeZone: timezone })).getTimezoneOffset();
            return localOffset - workshopOffset;
        }

        var workshopStartDate = new Date(workshopStartDateUtc);
        var offset = getTimezoneOffset(workshopTimezone) * 60 * 1000;  
        var workshopStartDateLocal = new Date(workshopStartDate.getTime() - offset);

        var flipdown = new FlipDown(workshopStartDateLocal.getTime() / 1000)
            .start()
            .ifEnded(() => {
                location.reload();
            });
 
        translateFlipdown();
    }


    document.body.addEventListener('click', function(event) {
        if (event.target.id === 'logoutLink') {
            event.preventDefault();
            document.getElementById('logoutForm').submit();
        }
    });
});

function showLoader2() {
    $('#loader2').removeClass('fade-out'); 
}

function hideLoader2() {
    $('#loader2').addClass('fade-out'); 
}

function showLoader() {
    $('#loader').addClass('loader-active');
}

function hideLoader() {
    $('#loader').removeClass('loader-active').hide();
}

function adjustDivHeight() {
    var navbarHeight = 68;
    var footerHeight = 39;
    var availableHeight = window.innerHeight - navbarHeight - footerHeight;
    document.getElementById('ckdisplay').style.minHeight = availableHeight + 'px';
}
window.onload = adjustDivHeight;
window.onresize = adjustDivHeight;